import Vue from 'vue';

Vue.filter('asDate', (time) => {
    if (time) {
        return time.format('DD.MM.YYYY');
    }
    return null;
});
